export const UserRoles = {
  joules_super_admin: "Joules Super Admin",
  joules_admin: "Joules Admin",
  organization_admin: "Organization Admin",
  facility_engineer: "Facility Engineer",
  facility_operator: "Facility Operator",
} as const;

export type UserRoleKey = keyof typeof UserRoles;

function toRoleLookupKey(role: string): string {
  const trimmed = role.trim();
  const snake = trimmed
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    .replace(/[\s-]+/g, "_")
    .toLowerCase();
  return snake;
}

/** Maps API role (snake_case or camelCase) to display label; falls back to title-cased raw value. */
export function getRoleDisplayName(role: string): string {
  const key = toRoleLookupKey(role) as UserRoleKey;
  if (key in UserRoles) {
    return UserRoles[key];
  }
  const normalized = role.replace(/_/g, " ").trim();
  if (!normalized) return role;
  return normalized.replace(/\b\w/g, (c) => c.toUpperCase());
}
